import React from "react";
import {Outlet, Route, Routes} from "react-router-dom";
import CreateManual from "../container/workOrder/CreateManual";
import CreateWorkOrder from "../container/workOrder/CreateWorkOrder";
import SelectSpecification from "../container/workOrder/SelectSpecification";
import UpdateManual from "../container/workOrder/UpdateManual";
import WorkOrderDetail from "../container/workOrder/WorkOrderDetail";
import WorkOrderList from "../container/workOrder/WorkOrderList";
import UpdateWorkOrder from "../container/workOrder/UpdateWorkOrder";
import RequestedList from "../container/workOrder/RequestedList";
import WorkOrderRecordList from "../container/workOrder/WorkOrderRecordList";

import MaintenanceList from "../container/workOrder/MaintenanceList";
import ChangeRequestList from "../container/workOrder/ChangeRequestList";
import CreateChangeRequest from "../container/workOrder/CreateChangeRequest";
import UpdateChangeRequest from "../container/workOrder/UpdateChangeRequest";
import ManageChangeTip from "../container/workOrder/ManageChangeTip";
import WorkOrderProcess from "../container/workOrder/WorkOrderProcess";
import WorkOrderReject from "../container/workOrder/WorkOrderReject";
import WorkOrderDelay from "../container/workOrder/WorkOrderDelay";
import WorkOrderComplete from "../container/workOrder/WorkOrderComplete";
import WritingTipsModal from "../container/workOrder/WritingTipsModal";

const WorkOrder = () => {
  return (
    <>
      <Routes>
        <Route path="/*" element={<WorkOrderList />} />
        <Route path="View/:id" element={<WorkOrderDetail />} />
        <Route path="CreateManual/:id" element={<CreateManual />} />

        <Route path="EditManual/:id" element={<UpdateManual />} />
        <Route path="Create/:id" element={<CreateWorkOrder />} />
        <Route path="Edit/:id" element={<UpdateWorkOrder />} />
        <Route path="SelectSpecification" element={<SelectSpecification />} />
        <Route path="RequestedList" element={<RequestedList />} />
        <Route path="Record" element={<WorkOrderRecordList />} />
        <Route path="List/:state" element={<MaintenanceList />} />
        <Route path="ChangeRequestList" element={<ChangeRequestList />} />
        <Route path="CreateChangeRequest" element={<CreateChangeRequest />} />
        <Route path="EditChangeRequest/:id" element={<UpdateChangeRequest />} />
        <Route path="ManageChangeTip" element={<ManageChangeTip />} />
        <Route path="Process" element={<WorkOrderProcess />} />
        <Route path="Reject" element={<WorkOrderReject />} />
        <Route path="Delay" element={<WorkOrderDelay />} />
        <Route path="Complete" element={<WorkOrderComplete />} />
      </Routes>
      <WritingTipsModal />
    </>
  );
};

export default WorkOrder;
